import { createFileRoute } from '@tanstack/react-router'
import { DocumentCollectionsPage } from '@/pages/document-collections/document-collections-page'

export const Route = createFileRoute('/document-collections/')({
  component: DocumentCollectionsPage,
})
